<template>
  <div>
    <RevTable
      :caption="i18n(translations.title, { orderId: orderId })"
      :collection="props.financialDetails.costBreakdown"
      :columns
      transparent-header
    >
      <template #body-title="{ item }">
        <div class="flex items-center">
          <IconInfo class="mr-8" size="small" />
          <span class="py-8">{{ item.financialEvent.label }}</span>
        </div>
      </template>
      <template #body-taxEcludedAmount="{ item }">
        {{ item.amountTaxExcluded.amount }}
      </template>
      <template #body-taxAmount="{ item }">
        {{ item.amountTax.amount }}
      </template>
      <template #body-taxIncludedAmount="{ item }">
        {{ item.amount.amount }}
      </template>
    </RevTable>
    <div
      class="border-static-default-low flex w-full justify-between border-t-1 p-24"
    >
      <span class="heading-3">
        {{ i18n(translations.payableBalance) }}
      </span>
      <span class="text-static-success-hi heading-3">
        {{
          i18n.price(
            {
              amount: financialDetails.payableAmount.amount,
              currency: financialDetails.payableAmount.currency,
            },
            { symbol: true },
          )
        }}
      </span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { GetSellerOrderFinancialDetails } from '@backmarket/http-api/src/api-specs-finance-tools/finance-seller-ledger/seller.types'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevTable } from '@ds/components/Table'
import { IconInfo } from '@ds/icons/IconInfo'

import type { Order } from '../../../../../../../../../../../../Tab.types'

import translations from './Table.translations'

const i18n = useI18n()

const props = defineProps<{
  financialDetails: GetSellerOrderFinancialDetails
  orderId: Order['id']
}>()

const columns = [
  { key: 'title', label: '' },
  {
    key: 'taxEcludedAmount',
    label: i18n(translations.taxEcludedAmount),
    align: 'end' as const,
  },
  {
    key: 'taxAmount',
    label: i18n(translations.taxAmount),
    align: 'end' as const,
  },
  {
    key: 'taxIncludedAmount',
    label: i18n(translations.taxIncludedAmount),
    align: 'end' as const,
  },
]
</script>
